(function () {
	let btnScrollTop;
	let frame = 0;
	const update = () => {
		frame = 0;
		if (!btnScrollTop?.isConnected) return;
		const show = scrollY > document.documentElement.clientHeight;
		if (btnScrollTop.classList.contains("show") !== show) btnScrollTop.classList.toggle("show", show);
	};
	const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
	const init = () => {
		btnScrollTop = document.querySelector(".scroll-top");
		if (btnScrollTop) btnScrollTop.onclick = () => window.scrollTo({ top: 0, behavior: "smooth" });
		schedule();
	};
	// 滚动监听只注册一次，区块重载只更新按钮引用。
	window.addEventListener("scroll", schedule, { passive: true });
	window.addEventListener("resize", schedule);
	document.addEventListener("shopify:section:load", init);
	document.addEventListener("shopify:section:unload", event => {
		if (btnScrollTop && event.target.contains(btnScrollTop)) btnScrollTop = null;
	});
	init();
})();
